// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2kpis","title":"BackImages_title__3fHbJ","images":"BackImages_images__Wk2S-"};